import { render } from "./main-table.vue?vue&type=template&id=ab480e60&scoped=true"
import script from "./main-table.vue?vue&type=script&lang=js"
export * from "./main-table.vue?vue&type=script&lang=js"

import "./main-table.vue?vue&type=style&index=0&id=ab480e60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab480e60"]])

export default __exports__